export default {
  name: "OptionListDialog",
  props: ["title", "text", "failText"],
  event: ["returnOption"],
  data() {
    return {
      dialog: false,
      options: [],
      table: {}
    };
  },
  methods: {
    showDialog(options, table) {
      this.options = options;
      this.table = table;
      this.dialog = true;
    },
    returnOption(option) {
      this.$emit("returnOption", option);
      this.dialog = false;
    }
  }
};
